import { useState, useEffect } from "react";
import { createStage } from "../gameHelpers";

export const useStage = (player, resetPlayer) => {
  const [stage, setStage] = useState(createStage());
  const [rowsCleared, setRowsCleared] = useState(0);

  useEffect(() => {
    setRowsCleared(0);

    const sweepRows = (newStage) =>
      newStage.reduce((accumulator, row) => {
        //if no emplty spaces are found in the row clear the row
        if (row.findIndex((cell) => cell[0] === 0) === -1) {
          setRowsCleared((prev) => prev + 1);
          //empty row added at top of accumulator array to replace clear row that is not added
          accumulator.unshift(new Array(newStage[0].length).fill([0, "clear"]));
          return accumulator;
        }
        //else not clear yet, add row into accumulator
        accumulator.push(row);
        return accumulator;
        //giving reducer an empty array to start adding rows into during stage row loop
      }, []);

    const updateStage = (prevStage) => {
      //clear stage
      const newStage = prevStage.map((row) =>
        row.map((cell) => (cell[1] === "clear" ? [0, "clear"] : cell))
      );

      //draw tetromino
      player.tetromino.forEach((row, y) => {
        row.forEach((value, x) => {
          if (value != 0) {
            newStage[y + player.pos.y][x + player.pos.x] = [
              value,
              `${player.collided ? "merged" : "clear"}`,
            ];
          }
        });
      });

      //check if player collided
      if (player.collided) {
        resetPlayer();
        return sweepRows(newStage);
      }
      return newStage;
    };

    setStage((prev) => updateStage(prev));
    //is resetPlayer needed?
  }, [player, resetPlayer]);

  return [stage, setStage, rowsCleared];
};
